import { Close } from 'components/icons'
import { BaseButton } from 'components/library/buttons'
import Translate from 'lang/Translate'
import { deleteScenario } from '../services'
import callApi from 'services/api/callApi'
import { useState } from 'react'

interface DeleteScenarioProps {
	handleCloseModal?: () => void // is inherited via HOC props
	reload: () => void
	id: number
}

const DeleteScenario = ({ handleCloseModal = () => {}, reload, id }: DeleteScenarioProps) => {
	const [loading, setLoading] = useState(false)

	/* istanbul ignore next */
	const clearScenario = async () => {
		setLoading(true)
		const { success, isLoading } = await callApi<boolean>("SCENARIO/DELETE", deleteScenario(id))
		success && reload()
		setLoading(isLoading)
		if(!isLoading) handleCloseModal()
	}

	return (
		<div className='create-scenario-modal' data-testid="scenario-delete-confirm">
			<div className='header flex-center border-bottom mb-4 is-justify-content-space-between'>
				<div className='flex-center'>
					<Translate className='is-size-5 has-text-weight-bold' text="Buttons.delete_scenario" />
				</div>
				<div className='flex-center pointer' onClick={handleCloseModal} tabIndex={0}>
					<Close />
				</div>
			</div>
			<div className='inputs-container'>
				<Translate text="Content.delete_scenario" />
				<BaseButton autofocus loading={loading} fieldId="" labelKey="Buttons.delete" buttonStyles='is-danger w-100 mt-4' onClick={clearScenario}/>
				<BaseButton fieldId="" labelKey="Buttons.cancel" buttonStyles='is-text w-100 mb-2 mt-2' onClick={handleCloseModal} />
			</div>
		</div>
	)
}

export default DeleteScenario